export type PassDirection = 'ASCENDING' | 'DESCENDING';

/** Normalize predictor and compact hex-shard direction values. */
export function normalizePassDirection(value: unknown): PassDirection | undefined {
  const direction = String(value ?? '').trim().toUpperCase();
  if (direction === 'ASCENDING' || direction === 'ASC' || direction === 'A') return 'ASCENDING';
  if (direction === 'DESCENDING' || direction === 'DESC' || direction === 'D') return 'DESCENDING';
  return undefined;
}
